<template>
  <i class="ips ips-icon" :class="iconClasses" @click="handleClick"></i>
</template>

<script>
export default {
  name: 'IpsIcon',
  props: {
    icon: {
      name: 'icon',
      description: 'The name of the icon',
      type: String,
      default: '',
      required: true,
    },
    size: {
      name: 'size',
      description: 'The icon size',
      type: String,
      default: 'md',
      required: false,
      validator: (value) => ['', 'sm', 'md', 'lg'].indexOf(value) !== -1,
    },
  },
  computed: {
    iconClasses() {
      const classesArray = [this.icon];
      classesArray.push(`ips-icon-${this.size}`);
      return classesArray;
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
